interface AdBannerProps {
  enabled: boolean;
  clickthroughUrl: string;
  imgUrl: string;
  showDisclaimer?: boolean;
  altText?: string;
  ariaLabel?: string;
  className?: string;
}

export default function AdBanner({
  enabled,
  clickthroughUrl,
  imgUrl,
  showDisclaimer = true,
  altText = "",
  ariaLabel = "",
  className = "",
}: AdBannerProps) {
  if (!enabled) {
    return null;
  }

  return (
    <div className={className}>
      {showDisclaimer && (
        <p className="hidden md:block text-xs text-center text-black opacity-55 mb-1">
          TED is supported by ads and partners
        </p>
      )}
      <a
        href={clickthroughUrl}
        target="_blank"
        rel="noopener noreferrer sponsored"
        aria-label={ariaLabel}
        className="block mx-auto"
        style={{ width: 320 }}
      >
        <img
          src={imgUrl}
          alt={altText}
          width={320}
          height={50}
          style={{ width: 320, height: 50, display: "block" }}
        />
      </a>
    </div>
  );
}
